import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	setCardMenuSelect,
	setIconHeaderContainer,
	setModalImageView,
	setNameHeaderCardContainer,
	setSelectCardMenu,
	setSelectLocationId,
	toggleActiveModal,
	toggleActiveModalImageView,
	toggleLoading,
	toggleMenuSelect,
} from "../modules/store/slices/ui/ui";
import { menuBack, menuSelect, menuSeparateMenus } from "../types/initStore/initUi";
import Emitter from "../helpers/emitters";
import { Assets } from "../assets";

export const useUiRedux = () => {
	const state = useSelector((state) => state.ui);
	const dispatch = useDispatch();

	const selectMenuOption = useCallback(
		(id) => {
			const findOption = menuSeparateMenus.find((menu) => menu.id === id);
			// console.log(findOption);
			Emitter.emit("onUpdatePlane", findOption.children);
			dispatch(setNameHeaderCardContainer(findOption.name));
			dispatch(toggleMenuSelect(menuSelect.secondary));
			dispatch(setCardMenuSelect(findOption.children));
		},
		[dispatch]
	);

	const activeLoading = (value) => {
		dispatch(toggleLoading(value));
	};

	const informationSelect = (id) => {
		dispatch(setSelectLocationId(id));
	};

	const backMenu = () => {
		Emitter.emit("clearPlanes", state.menuSelect);
		dispatch(toggleMenuSelect(menuSelect.principal));
		dispatch(setCardMenuSelect(menuBack.data));
		dispatch(setNameHeaderCardContainer(Assets.icon.city));
	};

	const goMoveLocationName = (name) => {
		const newArray = menuBack.data[0].children.concat(menuBack.data[1].children);
		const findLocation = newArray.find((card) => card.name === name);
		moveLocationMenu(findLocation);
	};

	const goMoveLocation = (id) => {
		const findLocation = state.cardMenuSelect.find((card) => card.id === id);
		moveLocationMenu(findLocation);
	};

	const moveLocationMenu = (data) => {
		dispatch(setIconHeaderContainer(Assets.icon.startblue));
		dispatch(setNameHeaderCardContainer(data.name));
		dispatch(setCardMenuSelect(data.children));
		dispatch(toggleMenuSelect(menuSelect.third));
		Emitter.emit("changeView", { hotspot: data.children });
	};

	const activeModalCard = (value = true, id = 0, nameMove = "") => {
		const findLocation = state.cardMenuSelect.find((card) => card.id === id);
		Emitter.emit("modalInformationMove", nameMove);
		dispatch(setSelectCardMenu(findLocation));
		dispatch(toggleActiveModal(value));
	};

	const closeModalCard = (value = false) => {
		dispatch(toggleActiveModal(value));
	};

	const setActiveModalViewImage = (value = false) => {
		dispatch(toggleActiveModalImageView(value));
	};

	const viewImageModal = (image = "") => {
		dispatch(setModalImageView(image));
		setActiveModalViewImage(true);
	};

	return {
		state,
		selectMenuOption,
		informationSelect,
		backMenu,
		goMoveLocation,
		goMoveLocationName,
		activeModalCard,
		closeModalCard,
		viewImageModal,
		setActiveModalViewImage,
		activeLoading,
	};
};
